import { render, staticRenderFns } from "./ImsEcnsEditModal.vue?vue&type=template&id=13dc8970&"
import script from "./ImsEcnsEditModal.vue?vue&type=script&lang=js&"
export * from "./ImsEcnsEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports